export const QUOTAION_API_PATH = {
  APPLY_SURCHARGES_XI: "v1/flights/apply-surcharges_xi/",
};
